module.exports = __webpack_public_path__ + "static/img/qinngranliao.f349983.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qinngranliao.jpeg
// module id = qssM
// module chunks = 1